<div class="container-fluid">
  <div class="row">
    <div class="col-md-3"></div>
    <div class="col-md-6">
      <form>
        <fieldset>
          <legend>Add New Association</legend>

          <div class="form-group ">
            <label>Name:</label>
            <input type="text" name="name" [(ngModel)]="addnewdata.name">

          </div>
          <div class="form-group ">
            <label>Code/Suffix/Abbreviation (eg NWOA)</label>
            <input type="text" name="code" [(ngModel)]="addnewdata.code">
          </div>

          <div>
            <label style="font-weight:600">Create website:</label>
            <div>
              <input type="checkbox" name="createwebsite" title="Create website" (change)="func()"
                [(ngModel)]="createWebsite" [(ngModel)]="addnewdata.createWebsite">
            </div>
          </div>
          <br />
          <div *ngIf="createWebsite">
            <div class="form-group ">
              <label>Subdomain:</label>
              <input type="text" name="subDomain" [(ngModel)]="addnewdata.subDomain">
            </div>

            <div>
              <label style="font-weight:600">Include Hunt Lease Liability Application:</label>
              <div>
                <input type="checkbox" name="hlApp" [(ngModel)]="addnewdata.hlApp">
              </div>
            </div>
            <div>
              <label style="font-weight:600">Include Timberland Liability Application:</label>
              <div>
                <input type="checkbox" name="tlApp" [(ngModel)]="addnewdata.tlApp">
              </div>
              <br />
            </div>
          </div>
        </fieldset>
        <div style="padding-top:0.5%;">
          <button style="float:right;" class="btn btn-outline-secondary" (click)=" onClickSave()">
            <span *ngIf="!savingData">Save</span>
            <div *ngIf="savingData" class="spinner-wrapper">
              <mat-spinner diameter="32" color="primary"></mat-spinner>
            </div>
          </button>
        </div>

      </form>

    </div>
    <div class="col-md-3"></div>
  </div>
</div>